import moment from "moment";

export function mapOrderToTicketCard(order) {
  if (!order) return null;
  const item = order.items?.[0];
  const eventDateRaw = order.eventDate;
  let eventMoment = null;
  if (eventDateRaw) {
    const parsed = moment(eventDateRaw);
    if (parsed.isValid()) eventMoment = parsed;
  }

  return {
    id: order._id || String(order.order_Id),
    orderNumber: order.invoice_Id || `IP-${order.order_Id}`,
    title: order.eventName || item?.name || order.type || "Event Ticket",
    tier: item?.name || order.type || "General Admission",
    quantity: item?.splits ?? 0,
    unitPrice: item?.price ?? 0,
    venue: order.eventVenue || "Venue details in invoice",
    dateLabel: eventMoment
      ? eventMoment.format("ddd, MMM D, YYYY · h:mm A")
      : `Purchased ${moment(order.createdAt).format("ddd, MMM D, YYYY")}`,
    eventMoment,
    purchasedAt: order.createdAt,
    totalAmount: order.totalAmount,
    payment: order.payments,
    status: order.status,
    order_Id: order.order_Id,
    ticket_group_id: item?.ticket_group_id,
    eventId: order.eventId,
    type: order.type,
  };
}

export function filterTicketsByTab(tickets, tab) {
  const today = moment().startOf("day");
  if (tab === "transferred") {
    return tickets.filter(
      (t) =>
        String(t.status || "").toLowerCase().includes("transfer") ||
        String(t.status || "").toLowerCase() === "transferred"
    );
  }
  if (tab === "past") {
    return tickets.filter((t) => t.eventMoment && t.eventMoment.isBefore(today));
  }
  if (tab === "upcoming") {
    return tickets.filter(
      (t) => !t.eventMoment || t.eventMoment.isSameOrAfter(today)
    );
  }
  return tickets;
}

export function filterTicketsBySearch(tickets, search) {
  const q = (search || "").trim().toLowerCase();
  if (!q) return tickets;
  return tickets.filter((t) => {
    const haystack = [
      t.title,
      t.tier,
      t.venue,
      t.orderNumber,
      t.dateLabel,
      t.payment,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}
